// extracted by mini-css-extract-plugin
export default {"title":"d_k","chart-navigation":"d_l","chart-navigation__left":"d_m","chart-navigation__right":"d_n"};